"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledReactTooltip = exports.DefaultIcon = exports.Button = exports.Border = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactTooltip = _interopRequireDefault(require("react-tooltip"));
var _cssHelpers = require("../../../styled/css-helpers");
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var Button = _styledComponents.default.button.attrs(function (_ref) {
  var hasAction = _ref.hasAction;
  return {
    type: hasAction ? 'button' : 'span',
    as: hasAction ? 'button' : 'span'
  };
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  cursor: ", ";\n  border: none;\n  background: transparent;\n  width: min-content;\n  align-self: center;\n  &:active {\n    filter: ", ";\n  }\n  ", "\n  ", "\n  ", ";\n"])), function (_ref2) {
  var hasAction = _ref2.hasAction;
  return hasAction ? 'pointer' : 'cursor';
}, function (_ref3) {
  var hasAction = _ref3.hasAction;
  return hasAction && 'brightness(0.9)';
}, _cssHelpers.nonSelectable, _cssHelpers.noBoxShadow, function (_ref4) {
  var $bsStyle = _ref4.$bsStyle;
  return $bsStyle;
});
exports.Button = Button;
var DefaultIcon = _styledComponents.default.span(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral([""])));
exports.DefaultIcon = DefaultIcon;
var Border = _styledComponents.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: ", "px solid grey;\n  border-radius: 50%;\n  width: min-content;\n  height: min-content;\n  padding: ", "px;\n  background-color: ", ";\n  ", "\n"])), function (_ref5) {
  var width = _ref5.width;
  return width;
}, function (_ref6) {
  var padding = _ref6.padding;
  return padding;
}, function (_ref7) {
  var background = _ref7.background;
  return background || 'transparent';
}, function (_ref8) {
  var $bsStyle = _ref8.$bsStyle;
  return $bsStyle;
});
exports.Border = Border;
var StyledReactTooltip = (0, _styledComponents.default)(_reactTooltip.default)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  &.__react_component_tooltip {\n    border-radius: 7px !important;\n    opacity: 1 !important;\n  }\n"])));
exports.StyledReactTooltip = StyledReactTooltip;